import { ScopeDefinition } from './scopes';

/**
 * These scopes _must_ be used to ensure it's an OpenID flow
 */
export const mandatoryOIDCScopes = ['openid'];
/**
 * These scopes can be optionally added to the OpenID flow
 */
export const optionalOIDCScopes = ['profile', 'email'];
/**
 * Only these scopes are used in the OIDC flow
 */
export const OIDCScopes = [...mandatoryOIDCScopes, ...optionalOIDCScopes];

/**
 * Scope definitions for OIDC scopes
 */
export const scopeDefinitions: { [key: string]: ScopeDefinition } = {
  openid: {
    name: 'Log in to your account via Atlassian',
    description:
      'Log in to your account via Atlassian, which permits access to your account ID and any personal information requested on this screen.',
  },
  profile: {
    name: 'View your profile',
    description:
      'View all profile information for your Atlassian account, regardless of your profile visibility settings. For example, your full name, public name, and avatar.',
  },
  email: {
    name: 'View your email address',
    description: 'View your email address for your Atlassian account.',
  },
};
